import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {InsolesCustomerAccountSummaryModel} from './insolesCustomerAccountSummary.model';

@Injectable()
export class InsolesCustomerAccountSummaryConverter extends HttpModelConverter<InsolesCustomerAccountSummaryModel> {

    constructor() {
        super();
    }

    protected createInstance(): InsolesCustomerAccountSummaryModel {
        return new InsolesCustomerAccountSummaryModel();
    }

    protected enrichObject(result: InsolesCustomerAccountSummaryModel, src: InsolesCustomerAccountSummaryModel) {
    }

}
